(function () {
  let isCleaning = false;
  let observer;

  function getMoonbundleDrawer() {
    return document.querySelector(
      '#moonbundle-cart-drawer, \
       .moonbundle-cart-drawer, \
       moonbundle-cart-drawer-block'
    );
  }

  function isMoonbundleDrawerOpen() {
    const drawer = document.querySelector(
      '#moonbundle-cart-drawer[open], \
       #moonbundle-cart-drawer.open, \
       #moonbundle-cart-drawer.active, \
       .moonbundle-cart-drawer[open], \
       .moonbundle-cart-drawer.open, \
       .moonbundle-cart-drawer.active, \
       moonbundle-cart-drawer-block[open], \
       moonbundle-cart-drawer-block.open, \
       moonbundle-cart-drawer-block.active'
    );

    if (!drawer) return false;

    // Ne rien faire si le drawer est en mode preview
    if (drawer.classList.contains('preview')) return false;

    return true;
  }

  function cleanup() {
    if (isCleaning) return;
    isCleaning = true;

    observer.disconnect();

    const body = document.body;
    const html = document.documentElement;

    if (!body || !html) {
      observe();
      isCleaning = false;
      return;
    }

    const moonbundleOpen = isMoonbundleDrawerOpen();

    if (moonbundleOpen) {
      body.style.setProperty("overflow", "hidden", "important");
      html.style.setProperty("overflow", "hidden", "important");

      body.classList.remove("overflow-hidden");
      html.classList.remove("overflow-hidden");

      body.removeAttribute("scroll-lock");
      html.removeAttribute("scroll-lock");

      body.style.removeProperty("position");
      body.style.setProperty("top", "0px", "important");
      body.style.removeProperty("width");
      body.style.removeProperty("pointer-events");

      html.style.removeProperty("pointer-events");

      document.querySelectorAll("dialog[open]").forEach((dialog) => {
        if (
          dialog.closest("#moonbundle-cart-drawer") ||
          dialog.closest(".moonbundle-cart-drawer") ||
          dialog.closest("moonbundle-cart-drawer-block")
        ) {
          return;
        }

        try {
          dialog.close();
        } catch (e) {
          dialog.removeAttribute("open");
        }
      });

      document.querySelectorAll(`
        .modal,
        .drawer,
        .popup,
        .overlay,
        .backdrop,
        .dialog-overlay,
        .modal-overlay,
        .drawer-overlay,
        [class*="overlay"],
        [class*="backdrop"]
      `).forEach((el) => {
        if (
          el.classList.contains("moonbundle-cart-drawer-overlay") ||
          el.closest("#moonbundle-cart-drawer") ||
          el.closest(".moonbundle-cart-drawer") ||
          el.closest("moonbundle-cart-drawer-block")
        ) {
          return;
        }

        el.style.setProperty("pointer-events", "none", "important");
        el.style.setProperty("opacity", "0", "important");
        el.style.setProperty("visibility", "hidden", "important");
      });

    } else {
      body.style.setProperty("overflow", "auto", "important");
      html.style.setProperty("overflow", "auto", "important");
    }

    observe();
    isCleaning = false;
  }

  function observe() {
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "scroll-lock", "open"]
    });
  }

  observer = new MutationObserver(() => {
    cleanup();
  });

  cleanup();
})();